import React, { FC } from 'react'

import styles from './Loading.module.scss'

export const Loading: FC = () => (
  <div className={styles.loading} />
)
